import { formGlobalStyles, formStyles } from './form.styles';
import { FASTElement, html } from '@microsoft/fast-element';
import { MediaSizeMixin } from '../../utilities/media-size-observer';
import { NatGenDesignSystem } from '../../natgen-design-system';

/**
 * @element natgen-form
 */
export class NatGenForm extends MediaSizeMixin(FASTElement) {
    connectedCallback(): void {
        super.connectedCallback();

        // Due to limitations of the ::slotted selector some form styles need to live in the light DOM.
        if(!formGlobalStyles.isAttachedTo(document))
            formGlobalStyles.addStylesTo(document);
    }
}

export const natGenFormDefinition = NatGenForm.compose({
    name: `${NatGenDesignSystem.prefix}-form`,
    template: html`<slot></slot>`,
    styles: formStyles
});
